import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { getCurrentUser } from 'aws-amplify/auth';

@Injectable({ providedIn: 'root' })
export class RedirectGuard implements CanActivate {
    constructor(private router: Router) { }

    async canActivate(): Promise<boolean> {
        try {
            const user = await getCurrentUser();

            if (user) {
                this.router.navigate(['/dashboard']);
            } else {
                this.router.navigate(['/login']);
            }
        } catch (error) {
            this.router.navigate(['/login']);
        }

        return false; // Block access to this guarded route itself
    }
}